import { render } from "./hrSidebar.vue?vue&type=template&id=b8825082"
import script from "./hrSidebar.vue?vue&type=script&lang=js"
export * from "./hrSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__